/* eslint-disable */
// AUTO-GENERATED by scripts/gen-config.js from .env.thirstycamel.yml — DO NOT EDIT OR COMMIT.
// Typed as a loose bag (matching the prior react-native-ultimate-config default
// export); app/config.ts re-types each field into the curated `config` object.
const config: Record<string, any> = {
  "APP_NAME": "Thirsty Camel",
  "BUNDLE_ID": {
    "ios": "com.myfoodlink.ios.thirstycamel-wa",
    "android": "au.com.lmg.thirstycamel_wa",
    "web": "NOT_APPLICABLE"
  },
  "BUNDLE_VERSION": 1,
  "MARKETING_VERSION": "3.4.20",
  "WHITE_LABEL_ID": "thirstycamel",
  "APP_STORE_ID": "1512061165",
  "BASE_TENANT": "TC",
  "BASE_URL": "https://mw.lmg-bw.au",
  "TILL_GATEWAY": "https://gateway.tillpayments.com/js/integrated/payment.1.3.min.js",
  "HOST_DOMAIN": "wa.thirstycamel.com.au",
  "DEFAULT_STORE": "C000141706",
  "DEFAULT_STORE_STATE": "WA",
  "SUPPORT_EMAIL": "online@wa.thirstycamel.com.au",
  "GIFT_CARD_STORE": "thirstycamelgiftstore",
  "GIFT_CARDS_PROMOTION_ID": "ThirstyCamel-gift-card",
  "FF_IS_GIFT_CARDS_ENABLED": true,
  "FF_GIFT_CARD_ALL_STORES": false,
  "ONESIGNAL_APP_ID": "938f2081-3f05-4265-92bf-d1d4258eab54",
  "OTEL_ENABLED": true,
  "OTEL_SERVICE_NAME": "frontend-thirstycamel",
  "OTEL_SAMPLE_RATE": 1,
  "OTEL_DEBUG": false,
  "USE_API_PROXY": true,
  "SENTRY_DSN": "https://b8167d415374b364ba8b8d41ef3fa710@o4504137358442496.ingest.us.sentry.io/4510655432097792",
  "APPLE_PAY_MERCHANT_NAME": "Thirsty Camel",
  "APPLE_PAY_MERCHANT_ID": "merchant.com.lmg.production"
};

export default config;
